export default __webpack_public_path__ + "514082a7a1aaa8fa8592d8f6db85d8cd.png";